<template>
  <transition name="modal" >
      <div class="modal-mask">
      <div class="modal-wrapper" >  
        <div class="modal-container" @click.stop>
          <!-- <span>
            FedEx is having 
            <a 
              href="https://www.fedex.com/en-us/service-alerts.html"
              target="_blank"
              :style="'cursor:pointer; text-decoration: underline;'"
            >
              nationwide shipping delays.
            </a>
          </span> -->
          <div class="modal-header">
            <slot name="header">
              {{ $t('downloadApp') }}
            </slot>
          </div>
          <div class="modal-body">
            <slot name="body">
              <ul>
                <li>
                  <span>ios</span>
                  <img src="../../assets/img/app_ios.png" alt="">
                </li>
                <li>
                  <span>android</span>
                  <img src="../../assets/img/app_android.png" alt="">
                </li>
              </ul>
            </slot>
          </div>
          <el-form>
            <el-form-item>
              <button
                v-on:submit.prevent
                @click="closeModal($event)"
                class="modal-default-button">{{ $t('close') }}</button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    </transition>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
export default {
  name: 'appModal',
  data() {
    return {
    }
  },
  methods: {
    ...mapMutations('navbar', ['validateRadiusHome', 'validateRadiusPurchase', 'toggleModal', 'resetHomeWithinRadius' ]),
    closeModal(e) {
      e.preventDefault();
      this.toggleModal(false);
      localStorage.setItem('showModalToken', false);
    },
  },
  watch: {
    header: function(newVal, oldVal) {
    },
    body: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.body = newVal;
      }
    },
    header: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.header = newVal;
      }
    },
  },
}
</script>

<style lang="less">
  @import "../../assets/css/modal.less";
</style>



// WEBPACK FOOTER //
// src/view/Modal/appModal.vue